export const options = {
  indexAxis: 'y',
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,

  plugins: {
    // legend: {
    //   position: 'right',
    // },
    legend: {
      labels: {
        fontColor: 'black',
      },
    },
    // title: {
    //   display: true,
    //   text: 'What People Choose',
    // },
  },
};
